$(document).ready(function () {
  if($('.banner-slider .banner-box').length > 1){  
    $('.banner-slider').slick({
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        adaptiveHeight: true
    });
  }

  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });

  $('.reviews-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
  });
  
});


  // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    
    $('.product-list').slick('refresh');
  
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

    $('.product-list').slick('refresh');
  });
  
  
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");


  // mobile Tab
  $(document).on('click','.select-label', function () {
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });




//  $('.slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: true,
//   asNavFor: '.js-slider-thumbnails'
// });
// $('.js-slider-thumbnails').slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   asNavFor: '.slider-for',
//   dots: true,
//   centerMode: true,
//   focusOnSelect: true
// });
			
$(function() { 
// Card's slider
//   $('.slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   fade: false,
//   asNavFor: '.js-slider-thumbnails'
// });
$('.js-slider-thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  // asNavFor: '.slider-for',
  dots: false,
  arrows: true,
  centerMode: false,
  focusOnSelect: true,
  infinite: false,
  responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      }
    ]
});
});

// PDP onclick availability scroll to top
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(initAvailabilityScroll, 500);
  document.querySelectorAll('.single-option-selector-product-template')
  .forEach(select => {
    select.addEventListener('change', function () {
      // give Shopify time to re-render availability
      setTimeout(initAvailabilityScroll, 300);
    });
  });

  function initAvailabilityScroll() {
    const availabilityBtn = document.querySelector('.store-availability-information__button');
    if (!availabilityBtn || availabilityBtn.dataset.scrollInit) return;
    availabilityBtn.dataset.scrollInit = "true"; // prevent duplicate bindings
    availabilityBtn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});

